import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { difference } from 'lodash-es'
import { useState } from 'react'

import {
  getDefaultIntervals,
  getIntervalsForDate,
  upsertRules,
  removeRules
} from 'components/availability/form/utils'

import { IntervalsEditor } from '../intervals_editor'
import Calendar from './calendar'

const getDefaultListViewIntervals = (daysIds, dates, days = {}) => {
  if (daysIds.length === 0) {
    return getDefaultIntervals()
  }

  return getIntervalsForDate(daysIds[0], dates, days) || getDefaultIntervals()
}

export const DatePopup = ({ timezone, dates, days, setDates, onClose, defaultDays = [] }) => {
  const [selectedDays, setSelectedDays] = useState(defaultDays)
  const [intervals, setIntervals] = useState(getDefaultListViewIntervals(defaultDays, dates, days))

  const toggleDay = (day) => {
    const isDayAdded = !selectedDays.includes(day)
    const newSelectedDays = isDayAdded ? [...selectedDays, day] : selectedDays.filter((x) => day !== x)

    if (isDayAdded && newSelectedDays.length === 1) {
      setIntervals(getDefaultListViewIntervals(newSelectedDays, dates, days))
    }

    setSelectedDays(newSelectedDays)
  }

  const handleSubmit = () => {
    if (selectedDays.length > 0 && intervals.some(({ error }) => error)) return

    let newRules = upsertRules(dates, selectedDays, intervals)
    newRules = removeRules(newRules, difference(defaultDays, selectedDays))

    setDates(newRules)

    onClose()
  }

  return (
    <SimplePopup
      onClose={onClose}
      title={I18n.t('publisher.availability.schedules.date_popup_note')}
      cancelLabel={I18n.t('publisher.action.cancel')}
      confirmLabel={I18n.t('publisher.action.apply')}
      onConfirm={handleSubmit}
    >
      <Calendar timezone={timezone} selectedDays={selectedDays} toggleDay={toggleDay} />
      {selectedDays.length > 0 && <IntervalsEditor intervals={intervals} setIntervals={setIntervals} />}
    </SimplePopup>
  )
}
